import { QSRPosMain } from "@/components/QSR/QSRPosMain";

const QSRPos = () => {
  return <QSRPosMain />;
};

export default QSRPos;
